import SharedAsset from '@zenbusiness/common-components/SharedAsset';
import Text from '@zenbusiness/common-components/Text';
import Title from '@zenbusiness/common-components/Title';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

import { BorderedBox } from '#client/pages/EducationStudio/components/BorderedBox';
import superstyled from '#client/pages/EducationStudio/utils/superstyled';

import { TextArea } from '../../TextArea';

import { Tip } from '../../CustomSVG/Tip/Tip';

export const SummaryCardTipSpacing = superstyled({
  tag: Tip,
  styles: {
    paddingBottom: '1.5rem'
  }
});

export const SummaryCardTextSpacing = superstyled({
  tag: Tip,
  styles: {
    paddingBottom: '1.5rem'
  }
});
export const SummaryCardBottomContainer = superstyled({
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    '& p': {
      marginBottom: '2.5rem',
      padding: '0'
    },
    '& button': {
      width: '100%',
      padding: '1.25rem 2rem',
      margin: '0 auto 2.5rem auto',
      [theme.breakpoints.up('md')]: {
        maxWidth: 'max-content'
      },
      '&:last-of-type': {
        margin: '0 0 2rem 0',
        alignSelf: 'flex-end'
      }
    }
  })
});

export const Container2columns = superstyled({
  tag: Box,
  styles: ({ theme }) => ({
    height: 'fit-content',
    width: '80%',
    marginLeft: 'auto',
    marginRight: 'auto',
    margin: '0 auto',
    maxWidth: '65rem',
    padding: '0 1rem',
    [theme.breakpoints.down('lg')]: {
      width: '90%'
    }
  })
});
export const StyledImageContainer = styled(Box)(({ theme }) => ({
  // image container bottomSpacing
  display: 'flex',
  justifyContent: 'center',
  marginBottom: '2rem !important',
  [theme.breakpoints.down('sm')]: {
    marginBottom: '1.5rem !important'
  }
}));

export const StyledSharedAsset = styled(SharedAsset)(({ theme }) => ({
  // responsiveImage
  width: '100%',
  height: 'auto',
  maxWidth: '28.125rem',
  [theme.breakpoints.up('md')]: {
    maxWidth: '31.25rem'
  },
  borderStyle: 'solid',
  borderWidth: '1px 5px 5px 1px',
  borderRadius: '1rem'
}));

export const StyledText = styled(Text)(({ theme }) => ({
  // bottomSpacing
  marginBottom: '2rem !important',
  [theme.breakpoints.down('sm')]: {
    marginBottom: '1.5rem !important'
  }
}));

export const DownloadButtonBottomSpacing = superstyled({
  tag: Button,
  styles: ({ theme }) => ({
    marginBottom: '2rem !important',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '1.5rem !important'
    },
    width: '100%',
    padding: '1rem 0',
    textTransform: 'none'
  })
});

export const StyledList = styled('ul')(({ theme }) => ({
  // .list - .bottomSpacing
  paddingLeft: '1.4rem',
  marginTop: '0.375rem',
  marginBottom: '2rem !important',
  [theme.breakpoints.down('sm')]: {
    marginBottom: '1.5rem !important'
  }
}));

export const StyledNextButton = styled(Button)(({ theme }) => ({
  // nextButton
  padding: '1.25rem 2rem',
  textTransform: 'none',
  marginBottom: '1rem',
  [theme.breakpoints.down('sm')]: {
    padding: '1.25rem 0',
    width: '100%'
  },
  '& .buttonRight': {
    float: 'right'
  }
}));

export const StyledDownloadButton = styled(Button)(({ theme }) => ({
  width: '100%',
  padding: '1rem 0',
  textTransform: 'none',
  marginBottom: '2rem !important',
  [theme.breakpoints.down('sm')]: {
    marginBottom: '1.5rem !important'
  }
}));

export const StyledTextArea = styled(TextArea)(({ theme }) => ({
  // bottonSpacing
  marginBottom: '2rem !important',
  [theme.breakpoints.down('sm')]: {
    marginBottom: '1.5rem !important'
  }
}));

export const StyledSummaryCardText = styled(Text)(({
  paddingBottom: '1.5rem'
}));

export const StyledUserInputText = styled(Text)(({ theme }) => ({
  marginBottom: '0.375rem !important',
  [theme.breakpoints.down('sm')]: {
    marginBottom: '1.5rem !important'
  }
}));

export const SummaryCardWithBottomSpacing = superstyled({
  tag: BorderedBox,
  propsNeeded: ['bgcolor'],
  styles: ({ theme, bgcolor }) => ({
    padding: '2rem',
    backgroundColor: theme.palette[bgcolor]?.main,
    [theme.breakpoints.down('sm')]: {
      padding: '1.5rem',
      marginBottom: '1.5rem !important'

    },
    marginBottom: '2rem !important'
  })
});

export const SummaryCardTitle = superstyled({
  tag: Title,
  styles: ({ theme }) => ({
    fontSize: '1.75rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.25rem'
    },
    paddingBottom: '1.5rem'
  })

});
export const StyledSummaryCardContainer = styled('div')(({ theme }) => ({
  marginLeft: 'auto',
  marginRight: 'auto',
  [theme.breakpoints.up('md')]: {
    maxWidth: '31.25rem'
  }
}));

export const TextAreaWithBottomSpacing = superstyled({
  tag: TextArea,
  styles: ({ theme }) => ({
    marginBottom: '2rem !important',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '1.5rem !important'
    }
  })
});
